<footer class="px-[25px] bg-white dark:bg-[#1b1d2a]">
    <div class="flex justify-between flex-wrap py-[22px] gap-x-[30px] gap-y-[15px] items-center max-md:flex-col">
        <div class="flex items-center gap-[4px] text-[14px] font-medium max-md:text-center text-theme-gray dark:text-white/60">© {{ currentYear }} <a href="https://www.kharaaj.com" class="text-primary">Kharaaj</a></div>
        <div class="justify-end md:justify-center items-center flex gap-[15px]">
        </div>
    </div>
</footer>
